import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket } from '@fortawesome/free-solid-svg-icons';

function AboutNova() {
  return (
    <div className="container">
      <header className="header-container">
        <FontAwesomeIcon
          icon={faRocket}
          className="rocket-icon"
          size="3x"
          style={{ color: '#9146ff', marginRight: '10px' }}
        />
        <h1>About Nova</h1>
        <p>
          At Nova, we believe that achieving your goals isn’t just about focusing on one area of your life—it’s about understanding how everything is connected. Nova is designed to give you a complete view of your health, fitness, work, relationships, and personal growth, helping you recognize patterns and make meaningful progress across every aspect of your life.
        </p>
      </header>

      <div className="body-container">
        <h2>Your AI Coach for a Balanced Life</h2>
        <p>
          Nova’s AI-driven platform doesn’t just focus on one goal at a time. By taking into account all the elements of your life, Nova can help you identify patterns and provide personalized suggestions that reflect your unique circumstances.
        </p>

        <h2>How Nova Helps You Succeed</h2>
        <h3>See the Big Picture</h3>
        <p>Set goals across all areas of your life—Nova helps you track everything, from health to work, family, and beyond. </p>
        <h3>Build Better Habits</h3>
        <p>Nova recognizes how progress in one area can impact others, helping you build habits that create balance and long-term growth. </p>
        <h3>Personalized Suggestions</h3>
        <p> Nova provides advice based on patterns it identifies across all areas of your life. </p>
        <h3>Stay Organized</h3>
        <p>Keep track of your goals and habits, and make adjustments along the way. </p>
      </div>
    </div>
  );
}

export default AboutNova;
